// extracted by mini-css-extract-plugin
module.exports = {"link":"ALink_link__tGrXg"};